import BaseModel from '@/orm/models/BaseModel';

export default class CountryPayFrequency extends BaseModel {
  static entity = 'countryFrequency';

  static primaryKey = ['countryId', 'payFrequencyId'];

  static fields() {
    return {
      countryId: this.attr(null),
      payFrequencyId: this.attr(null),
    };
  }

  static apiConfig = {}
}
